<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-bind:disabled="formSubmitted" v-on:submit.prevent="resetPassword">
        <v-container>
          <v-row>
            <v-text-field
              v-model="email"
              v-bind:rules="emailRules"
              v-bind:error-messages="emailErrors"
              label="email"
              prepend-inner-icon="mdi-at"
              variant="solo-filled" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              v-model="code"
              v-bind:rules="codeRules"
              v-bind:error-messages="codeErrors"
              @update:model-value="codeErrors = []"
              label="verification code"
              prepend-inner-icon="mdi-code-tags"
              variant="solo-filled" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              type="password"
              label="password"
              v-model="password"
              v-bind:rules="passwordRules"
              prepend-inner-icon="mdi-lock"
              variant="solo-filled" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-text-field
              type="password"
              label="re-type password"
              v-model="repassword"
              v-bind:rules="[passwordConfirmationRule]"
              prepend-inner-icon="mdi-lock"
              variant="solo-filled" flat
              block
              required>
            </v-text-field>
          </v-row>

          <v-row>
            <v-btn id="confirm-password-reset" type="submit" v-bind:disabled="formSubmitted" class="bg-primary"  block>Confirm</v-btn>
          </v-row>
        </v-container>
      </v-form>
    </div>

    <div class="text-center mt-5">
      <router-link to="/account/login">Go to the login page</router-link>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'
import LoginLogo from './components/LoginLogo.vue';
import Helper from '../../components/helper.js';

export default {
  name: 'ResetPassword',
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      email: "",
      emailErrors: [],
      emailRules: [
        v => !!v || 'Please, enter email address.',
        v => Helper.isEmailValid(v) || 'Please, enter valid email address.',
      ],

      code: "",
      codeErrors: [],
      codeRules: [
        v => !!v || "Please, enter verification code.",
      ],

      password: "",
      passwordRules: Helper.getPasswordRules(this),

      repassword: "",

      formSubmitted: false,
    };
  },
  mounted: function() {
    this.email = this.$route.params.email || '';
    this.code = this.$route.params.code || '';
  },
  computed: {
    passwordConfirmationRule() {
      return this.password === this.repassword || "Please, retype the password correctly.";
    }
  },
  methods: {
    async resetPassword() {
      const validForm = await this.$refs.form.validate();

      if (!validForm.valid) {
        return;
      }

      this.codeErrors = [];

      const params = {
        email: this.email,
        code: this.code,
        password: this.password,
      };

      try {
        this.formSubmitted = true;
        const authStore = useAuthStore();
        await authStore.forgotPasswordSubmit(params);
        this.$router.push('/account/login');
      } catch (e) {
        if (e?.name === 'CodeMismatchException' || e?.name === 'ExpiredCodeException') {
          this.codeErrors = [e.message];
        } else {
          this.emailErrors = e && e.message ? e.message : "Something happened!";
        }
      } finally {
        this.formSubmitted = false;
      }
    }
  }
}
</script>

<style>
#confirm-password-reset:focus {
  outline-width: 1px;
  outline-style: auto;
  outline-offset: 3px;
}
</style>
